import React from 'react';
import { Phone, Mail, MapPin, Clock, MessageSquare, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';

const Contact = () => {
  const contactInfo = [
    {
      icon: <Phone className="h-6 w-6" />,
      title: 'Telefon',
      details: [
        { text: '+373 231 10000', action: 'tel:+37323110000' },
        { text: '+373 22 910 910', action: 'tel:+37322910910' }
      ]
    },
    {
      icon: <Mail className="h-6 w-6" />,
      title: 'Email',
      details: [{ text: 'info@interlink.md', action: 'mailto:info@interlink.md' }]
    },
    {
      icon: <Clock className="h-6 w-6" />,
      title: 'Program de Lucru',
      details: [{ text: 'Lun - Vin: 09:00 - 18:00' }, { text: 'Sâm: 10:00 - 14:00' }]
    }
  ];

  return (
    <>
      <Hero
        title="Contacte"
        subtitle="Suntem aici pentru tine. Alege modalitatea preferată de contact."
      >
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <a
            href="tel:+37323110000"
            className="bg-white/10 hover:bg-white/20 text-white px-6 py-3 rounded-lg transition-all duration-300 flex items-center justify-center hover:scale-105"
          >
            <Phone className="h-5 w-5 mr-2" />
            Sună Acum
          </a>
          <Link
            to="/send-message"
            className="btn-accent"
          >
            <MessageSquare className="h-5 w-5 mr-2 inline" />
            Trimite Mesaj
          </Link>
        </div>
      </Hero>

      {/* Relocation Notice */}
      <section className="relative -mt-10 z-10">
        <div className="container mx-auto px-4">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden border-2 border-accent">
            <img
              src="/img/anaunt_locatie_noua.jpg"
              alt="Anunț important: Interlink Comunicații SRL s-a mutat pe str. Decebal 13, etaj 2, biroul 206, intrarea prin lateralul clădirii Răut"
              className="w-full h-auto"
            />
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="relative z-10 mt-8">
        <div className="container mx-auto px-4">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-3">
              <div className="p-8 bg-secondary-50">
                <div className="flex items-center mb-6">
                  <MapPin className="h-6 w-6 text-primary-500" />
                  <h2 className="text-2xl font-heading font-bold ml-3 text-secondary-900">Locația Noastră</h2>
                </div>
                <p className="text-lg text-secondary-500 mb-4">Ne găsești la adresa:</p>
                <p className="text-xl font-heading font-semibold text-secondary-800 mb-2">
                  mun. Bălți, str. Decebal, 13
                </p>
                <p className="text-lg text-secondary-700 mb-6">
                  Etaj 2, biroul 206 — intrarea se face prin lateralul clădirii "Răut"
                </p>
                <a
                  href="https://maps.app.goo.gl/2AvdigBc1Kj123F78"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-primary-500 hover:text-primary-700 transition-colors font-medium"
                >
                  <span className="mr-2">Deschide în Google Maps</span>
                  <ExternalLink className="w-4 h-4" />
                </a>
              </div>
              <div className="lg:col-span-2">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4972.140259573975!2d27.94098779934713!3d47.769740091626254!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40cb61350ea0d741%3A0x3eebd0161dc45af3!2sInterlink%20Comunicatii%20SRL!5e1!3m2!1sru!2s!4v1738252557553!5m2!1sru!2s"
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Interlink Comunicatii SRL Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-20 px-4">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {contactInfo.map((info, index) => (
              <div
                key={index}
                className="card-base p-8 animate-on-scroll"
                style={{ transitionDelay: `${index * 0.1}s` }}
              >
                <div className="flex items-center mb-4">
                  <div className="bg-primary-50 p-3 rounded-xl text-primary-500">
                    {info.icon}
                  </div>
                  <h3 className="text-lg font-heading font-semibold ml-3 text-secondary-900">{info.title}</h3>
                </div>
                <div className="space-y-2">
                  {info.details.map((detail, i) => (
                    <p key={i} className="text-secondary-500">
                      {detail.action ? (
                        <a href={detail.action} className="hover:text-primary-600 transition-colors">
                          {detail.text}
                        </a>
                      ) : (
                        detail.text
                      )}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
